export default __webpack_public_path__ + "media/images/icons/start_shine-b940a0c20aeb4fcf6371a961ae042341.svg";